




























import Toolbar from '@/components/Toolbar.vue';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Inject, Prop } from 'vue-property-decorator';

type InviteFn = (email: string) => Promise<void>;

@Component
export default class InviteForm extends Vue {
  public $refs!: {
    form: HTMLFormElement;
  };

  @Prop(String) private readonly title!: string;
  @Prop(Function) private readonly invite!: InviteFn;

  private email = '';
  private emailRules = [
    (v: string) => !!v || 'E-mail Required',
    (v: string) =>
      // tslint:disable-next-line: max-line-length
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        v,
      ) || 'E-mail must be valid',
  ];
  private inviteError = '';
  private inviteSuccess = false;

  private resetFormMessages() {
    this.inviteError = '';
    this.inviteSuccess = false;
  }

  private inviteAdmin() {
    this.resetFormMessages();

    if (!this.$refs.form.validate()) {
      return;
    }
    (this as any).invite(this.email).then(
      () => {
        this.inviteSuccess = true;
      },
      (error: any) => {
        this.inviteError = error.message || 'Unknown Server Error';
      },
    );
  }
}
